<template>
	<div class='img-upload'>
		<el-upload action='' class="avatar-uploader" :show-file-list="false"  :http-request="uploadImg" >
			<div class="img-upload-con">
				<img v-if="imageUrl" :src="imageUrl" class="avatar">
				<div v-else>
					<i class="el-icon-plus avatar-uploader-icon"></i>
					<p>上传图片</p>
				</div>
			</div>
		</el-upload>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import * as qiniu from 'qiniu-js'
import utils from '@/utils/utils.js'

export default {
	name:'ImageUpload',
	props: {
		imageUrl: {
			default: '',
			type: String
		},
		currentId: {
			default: '',
			type: String
		}
	},
	components: {},
	data() {
		return {
		}
	},
	//方法集合
	methods: {
		...mapActions('user', ['getUptoken']),
		async uploadImg(res) {
			// 上传之前的校验
			let file = res.file
			if(!this.beforeUpload(file)) return
			let { data } = await this.getUptoken()

			let uptoken, qniu_domain
			if (data.isSuccess) {
				uptoken = data.data.uptoken
				qniu_domain = data.data.qniu_domain
			} else {
				this.$message.error('获取token失败')
				return
			}
			let fileName = this.getNewFileName(file), self = this
			let observable = qiniu.upload(file, fileName, uptoken)
			let subscription = observable.subscribe({
				err(res) {
					self.$message({
						message: '上传图片到七牛失败',
						type: 'err'
					})
				},
				complete(res) {
					self.$emit('update:imageUrl', qniu_domain + res.key)
					self.$message({
						message: '上传图片到七牛成功',
						type: 'success'
					})
				}
			}) //上传开始

			// console.log(qniu_domain + fileName)
			// this.imageUrl = qniu_domain + fileName

		},
		getNewFileName(file) {
			let name = file.name
			let ext = /\.[^\.]+$/.exec(name)[0]
			return `${this.currentId}_${utils.getRandomString(10)}${ext}`
		},
		beforeUpload(file) {
			let { type, size} = file
			if (!/^image\//.test(type)) {
				this.$message.error('请选择图片类型')
				return false
			}
			if (size > 2 * 1024 * 1024) {
				this.$message.error('缩略图大小不能大于2M')
				return false
			}
			return true
		},

	},
}
</script>
<style lang='scss' scoped>
.img-upload{
	width: 100%;
	height: 100%;
	border: 1px dashed #dedede;
	&:hover{
		border-color: #fece00;
	}
	.el-icon-plus{
		display: block;
		width: 155px;
		height: 45px;
		background-color: #fece00;
		font-size:24px ;
		line-height: 45px;
		color: #fff;
	}
	p{
		width: 100%;
		height: 40px;
		letter-spacing: 2px;
		color: #666666;
		line-height: 40px;
	}
	.el-upload{
		height: 100%;
	}
}
.img-upload-con{
		height: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-content: center;
	img{
		max-width: 98%;
		max-height: 98%;
	}
}

</style>
